var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1864_10727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.268 14.2681C12.1201 16.416 8.6377 16.416 6.48982 14.2681C4.34194 12.1203 4.34194 8.63786 6.48982 6.48998C8.6377 4.34209 12.1201 4.34209 14.268 6.48998C16.4159 8.63786 16.4159 12.1203 14.268 14.2681ZM14.5161 16.6365C11.604 18.5663 7.64148 18.2482 5.07561 15.6824C2.14667 12.7534 2.14667 8.00469 5.07561 5.07576C8.00454 2.14683 12.7533 2.14683 15.6822 5.07576C18.4922 7.88571 18.6063 12.3706 16.0247 15.3166L20.2793 19.5713L18.8651 20.9855L14.5161 16.6365Z",
    fill: "#171717",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1864_10727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8a36ab25.svg";
export { ForwardRef as ReactComponent };